import { Group, Button, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';

import type { TWhitelist, TWhitelistUpdateParams } from '../store/types';

type FormData = Partial<TWhitelistUpdateParams>;

type Props = {
  whitelistItem: TWhitelist;
  onSubmit: (params: TWhitelistUpdateParams) => void;
  onClose: () => void;
};

export const EditWhitelistForm = (props: Props) => {
  const { whitelistItem, onSubmit, onClose } = props;

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      ip: whitelistItem.ip,
      note: whitelistItem.note,
    },
    validate: {
      ip: (value) => value && value.length < 1 ? 'Введите IP адрес' : null,
      note: (value) => value && value.length < 1 ? 'Введите описание' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    const params: TWhitelistUpdateParams = {
      itemId: whitelistItem.id,
      ip: values.ip ?? '',
      note: values.note ?? '',
    };
    onSubmit(params);
    onClose();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <TextInput
        label="IP"
        withAsterisk
        key={form.key('ip')}
        {...form.getInputProps('ip')}
      />
      <TextInput
        label="Описание"
        withAsterisk
        key={form.key('note')}
        {...form.getInputProps('note')}
      />
      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit">
          Редактировать
        </Button>
      </Group>
    </form>
  );
};
